import React from 'react'
import IFCA from '../../assets/images/ifca-white-logo.png'
import { APP_VERSION } from '@account-root/account-react/src/versionControl/version'

export const CopyRight = () => {
  return (
    <div
      className="copy-right desc"
      style={{
        marginBottom: '12px',
        position: 'fixed',
        bottom: '0',
        width: '100%',
      }}
    >
      <div style={{ marginBottom: '4px' }}>
        <img
          src={IFCA}
          alt="CopyRight"
          className="ifca-logo"
          style={{ marginLeft: '8px' }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '12px',
          color: '#ffffff',
          opacity: 0.8,
        }}
      >
        <span style={{ marginLeft: '8px' }}>
          © Copyright 2025 IFCA MSC Berhad
        </span>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '12px',
            alignItems: 'flex-end',
          }}
        >
          {/* Version number */}
          <span style={{ marginRight: '8px' }}>{APP_VERSION || ''}</span>
          <span style={{ marginRight: '8px' }}>All Rights Reserved.</span>
        </div>
      </div>
    </div>
  )
}
